<template>
  <div>
    <b-form @submit="onSubmit">
      <b-row>
        <b-col>
          <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" required v-model="systemUserEdit.login" :state="inputLoginState"  aria-describedby="input-live-help input-live-feedback" trim />
            <b-form-invalid-feedback id="input-live-feedback">
              {{ $t('Enter only english letters, numbers, at least 1 letter') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Generated password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" disabled  v-model="genPass"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="password" v-model="systemUserEdit.password"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Confirm password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="password" v-model="confirmPassword"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('IPv4')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
                <b-form-input style="text-align:right" type="text" v-model="systemUserEdit.ip4"/>
                <template v-slot:append>
                  <b-form-input style="text-align:left;margin-left:5px;max-width:30px" type="text" v-model="systemUserEdit.mask4"/>
                </template>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('IPv6')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
                <b-form-input style="text-align:right" type="text" v-model="systemUserEdit.ip6"/>
                <template v-slot:append>
                  <b-form-input style="text-align:left;margin-left:5px;max-width:30px" type="text" v-model="systemUserEdit.mask6"/>
                </template>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('API Token')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group size="sm">
              <b-form-input type="text" v-model="systemUserEdit.token"/>
                <template v-slot:append >
                  <b-button small variant="info" style="margin-bottom:2px" @click="systemUserEdit.token=generatePass(30)">{{ $t('Create') }}</b-button>
                </template>
              </b-input-group>
          </b-form-group>
          </b-col>
      </b-row>
      <b-row align-content="end">
        <b-col>
          {{ $t('Groups') }}
        </b-col>
        <b-col>
          <b-button variant="success" @click="ShowAddGroup" size="sm" style="float: right">{{ $t('Add') }}</b-button>
        </b-col>
      </b-row>
      <b-row style="margin-top:1rem">
        <basic-table
          v-if="systemUsersGroups"
          :items="systemUsersGroups"
          :fields="fieldsSystemUsersGroups"
          @ClickOnDeleteButton="DeleteSysGroup"
          isDelete="true"/>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="submit" variant="success" style="float: right; width: 100px">{{ $t('Save') }}</b-button>
        </b-col>
        <b-col sm="3">
          <b-button variant="secondary" style="float: right ;width: 100px" @click="hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-modal ref="addGroup" hide-footer>
      <basic-table
        :items="allSystemUsersGroups"
        :fields="fieldsAllSystemUsersGroups"
        @RowSelected="SysGroupSelected"/>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="AddSysGroup">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$refs.addGroup.hide()">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    systemUser: null
  },
  data () {
    return {
      systemUserEdit: {
        'user_id': 0,
        'login': '',
        'password': '',
        'token': '',
        'ip4': '0.0.0.0',
        'ip6': '::',
        'is_dealer': false,
        'mask4': 0,
        'mask6': 0,
        'sys_groups': []
      },
      fieldsSystemUsersGroups: [
        { key: 'group_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'group_info', label: this.$i18n.t('Information'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      fieldsAllSystemUsersGroups: [
        { key: 'group_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'group_info', label: this.$i18n.t('Information'), sortable: true }
      ],
      genPass: null,
      confirmPassword: null,
      sysGroupToAdd: null
    }
  },
  methods: {
    async onSubmit (event) {
      if (this.validation()) {
        event.preventDefault()
        if (this.systemUserEdit.password === this.confirmPassword) {
          this.systemUserEdit.mask4 = Number(this.systemUserEdit.mask4)
          this.systemUserEdit.mask6 = Number(this.systemUserEdit.mask6)
          let response = this.systemUser
            ? this.$store.dispatch('SystemUsers/UPDATE_SYSTEM_USER', this.systemUserEdit)
            : this.$store.dispatch('SystemUsers/CREATE_SYSTEM_USER', this.systemUserEdit)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$emit('refreshTable')
              this.$root.$emit('makeToasts')
            }
          })
        }
      }
    },
    hide () {
      this.$emit('hide')
    },
    generatePass (length = 10) {
      let Pass = ''
      var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var lowercase = 'abcdefghijklmnopqrstuvwxyz'
      var numbers = '0123456789'
      var all = uppercase + lowercase + numbers
      for (var index = 0; index < length; index++) {
        var character = Math.floor(Math.random() * all.length)
        Pass += all.substring(character, character + 1)
      }
      return Pass
    },
    validation () {
      if (this.systemUserEdit.login.length === 0) {
        return false
      }
      let strArray = this.systemUserEdit.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_/'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.systemUserEdit.login.length
    },
    ShowAddGroup () {
      if (!this.allSystemUsersGroups.length) {
        this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Not found available system groups'))
        return
      }
      this.$refs.addGroup.show()
    },
    SysGroupSelected (sysGroup) {
      this.sysGroupToAdd = sysGroup
    },
    AddSysGroup () {
      if (this.sysGroupToAdd) {
        this.systemUserEdit.sys_groups.push(this.sysGroupToAdd.group_id)
      }
      this.$refs.addGroup.hide()
    },
    DeleteSysGroup (delSysGroup) {
      this.systemUserEdit.sys_groups = this.systemUserEdit.sys_groups.filter(item => { return !(delSysGroup.group_id === item) })
    }
  },
  computed: {
    inputLoginState () {
      return this.validation()
    },
    systemUsersGroups () {
      return this.$store.getters['SystemUsers/SYSTEM_USERS_GROUPS'].filter(item => { return this.systemUserEdit.sys_groups.includes(item.group_id) })
    },
    allSystemUsersGroups () {
      return this.$store.getters['SystemUsers/SYSTEM_USERS_GROUPS'].filter(item => { return !this.systemUserEdit.sys_groups.includes(item.group_id) })
    }
  },
  mounted () {
    if (this.systemUser) {
      this.systemUserEdit = JSON.parse(JSON.stringify(this.systemUser))
      this.confirmPassword = JSON.parse(JSON.stringify(this.systemUser.password))
    } else {
      this.genPass = this.generatePass()
      this.systemUserEdit.password = JSON.parse(JSON.stringify(this.genPass))
      this.confirmPassword = JSON.parse(JSON.stringify(this.genPass))
    }
    this.$store.dispatch('SystemUsers/GET_SYSTEM_USERS_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemUsers/form.vue